const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickeName: state => state.user.nickName,
  userId: state => state.user.userId
}
export default getters
